/**
 * Field sections configuration
 * Defines how fields are grouped in the UI
 * Migrated from Alpine.js field-config.js
 */

export interface SectionConfig {
  title: string;
  order: number;
  layout: 1 | 2; // 1 = full width, 2 = half width (side-by-side)
  columns: 1 | 2; // 1 = single column, 2 = two columns (for fields inside section)
}

export const FIELD_SECTIONS: Record<string, SectionConfig> = {
  basic: {
    title: 'Basic Information',
    order: 1,
    layout: 1, // Full width
    columns: 1, // Single column (custom layout in BasicInfoSection)
  },

  // ========== Model Configuration ==========
  models: {
    title: 'Model Configuration',
    order: 2,
    layout: 1, // Full width
    columns: 2, // Two columns for compact layout
  },

  // Model capability sections (auto-generated from backend schema)
  models_vision: {
    title: '视觉模型',
    order: 2.1,
    layout: 2, // Half width
    columns: 1,
  },

  models_stt: {
    title: '语音输入',
    order: 2.2,
    layout: 2, // Half width
    columns: 1,
  },

  models_reasoning: {
    title: '推理能力',
    order: 2.3,
    layout: 2, // Half width
    columns: 1,
  },

  models_task: {
    title: '任务模型',
    order: 2.5,
    layout: 2, // Half width
    columns: 1,
  },

  features: {
    title: 'Features',
    order: 4,
    layout: 2, // Half width
    columns: 2, // Two columns (checkboxes side-by-side)
  },

  message_processing: {
    title: 'Message Processing',
    order: 5,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  session_summary: {
    title: 'Session Summary',
    order: 5.5, // Between message_processing and advanced
    layout: 2, // Half width
    columns: 1, // Single column
  },

  advanced: {
    title: 'Advanced Settings',
    order: 6,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  memory: {
    title: 'Memory Configuration',
    order: 7,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  memory_prompts: {
    title: 'Memory Custom Prompts',
    order: 8.5,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  memory_user: {
    title: 'User Memory',
    order: 9,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  memory_agent: {
    title: 'Agent Memory',
    order: 9.5,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  memory_query: {
    title: 'Memory Query Settings',
    order: 10,
    layout: 2, // Half width
    columns: 2, // Two columns
  },

  memory_ebbinghaus: {
    title: 'Memory Decay (Ebbinghaus)',
    order: 10.5, // Between memory_query and custom_tools
    layout: 2, // Half width
    columns: 2, // Two columns (number fields side-by-side)
  },

  custom_tools: {
    title: 'Custom Tools',
    order: 11,
    layout: 2, // Half width
    columns: 1, // Single column (JSON needs full width)
  },

  builtin_tools: {
    title: 'Builtin Tools',
    order: 12,
    layout: 2, // Half width
    columns: 1, // Single column (JSON needs full width)
  },

  mcp_tools: {
    title: 'MCP Servers',
    order: 13,
    layout: 2, // Half width
    columns: 1, // Single column (JSON needs full width)
  },

  tools_execution: {
    title: '工具执行',
    order: 13.3,
    layout: 2, // Half width
    columns: 1,
  },

  tools_compression: {
    title: '工具结果压缩',
    order: 13.5,
    layout: 2, // Half width
    columns: 1,
  },

  team: {
    title: 'Team Configuration',
    order: 14,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  prompts: {
    title: 'System Prompts',
    order: 15,
    layout: 1, // Full width
    columns: 1, // Single column (large text areas)
  },

  first_message: {
    title: 'First Message Hook',
    order: 16,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  response_classifier: {
    title: '匹配参数',
    order: 17,
    layout: 2, // Half width
    columns: 1, // Single column
  },

  // Skills configuration is now managed in the dedicated Skills tab
};

export default FIELD_SECTIONS;
